import React from "react";
import { ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://images.pexels.com/photos/12154464/pexels-photo-12154464.jpeg";

export default function Hero() {
  const scrollToDon = (e) => {
    e.preventDefault();
    document.querySelector("#don")?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollToVision = (e) => {
    e.preventDefault();
    document.querySelector("#vision")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden bg-[#FAF7F2]"
    >
      <div className="max-w-[1400px] mx-auto px-6 pt-10 lg:pt-20 pb-24 lg:pb-36 grid lg:grid-cols-12 gap-10 items-center">
        {/* Copy block */}
        <div className="lg:col-span-7 relative z-10">
          <p
            className="sdm-divider sdm-fade-up"
            data-testid="hero-eyebrow"
          >
            Paris · Refuge Urbain · Association Les Mamans Reines
          </p>
          <h1
            data-testid="hero-title"
            className="font-serif-display text-[2.6rem] sm:text-6xl lg:text-[5.2rem] leading-[1.02] text-[#4A192C] mt-8 sdm-fade-up sdm-fade-up-delay-1"
          >
            Ici, chaque mère
            <br />
            <span className="italic text-[#C5A059]">redevient</span> une Reine.
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-8 text-lg leading-relaxed text-[#2C1E23]/85 max-w-xl sdm-fade-up sdm-fade-up-delay-2"
          >
            Le premier sanctuaire urbain parisien dédié aux mères victimes de
            violences conjugales. Un lieu sacré où l&apos;on accueille,
            transmet et fait renaître la dignité, la souveraineté et la
            résilience.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4 sdm-fade-up sdm-fade-up-delay-3">
            <a href="#don" onClick={scrollToDon} data-testid="hero-donate-button" className="sdm-btn-primary">
              Soutenir le Sanctuaire
            </a>
            <a href="#vision" onClick={scrollToVision} data-testid="hero-vision-button" className="sdm-btn-ghost">
              Découvrir la Vision
            </a>
          </div>

          <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg sdm-fade-up sdm-fade-up-delay-4">
            {[
              { n: "1er", l: "refuge urbain à Paris" },
              { n: "3", l: "ateliers de souveraineté" },
              { n: "∞", l: "sœurs, filles, reines" },
            ].map((s) => (
              <div key={s.l} className="border-t border-[#4A192C]/25 pt-4">
                <div className="font-serif-display text-3xl text-[#4A192C]">
                  {s.n}
                </div>
                <div className="text-[0.68rem] tracking-[0.2em] uppercase text-[#6B585F] mt-1">
                  {s.l}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Visual block */}
        <div className="lg:col-span-5 relative">
          <div className="relative aspect-[4/5] overflow-hidden sdm-fade-up sdm-fade-up-delay-2">
            <img
              src={HERO_IMG}
              alt="Lumière sacrée sous une voûte architecturale"
              className="w-full h-full object-cover"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#4A192C]/40 via-transparent to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 text-[#FAF7F2]">
              <div className="sdm-ornament mb-3" />
              <p className="font-serif-display italic text-xl leading-snug">
                « Tu étais une ombre. Tu entres en reine. »
              </p>
            </div>
          </div>
          <div className="hidden lg:block absolute -bottom-6 -left-10 w-40 h-40 border border-[#C5A059]" />
          <div className="hidden lg:block absolute -top-8 -right-8 w-24 h-24 bg-[#C5A059]/20" />
        </div>
      </div>

      <a
        href="#vision"
        onClick={scrollToVision}
        data-testid="hero-scroll-hint"
        className="hidden lg:flex items-center gap-2 absolute bottom-8 left-1/2 -translate-x-1/2 text-[#4A192C] text-[0.68rem] tracking-[0.28em] uppercase"
      >
        Descendre <ArrowDown className="w-4 h-4 animate-bounce" />
      </a>
    </section>
  );
}
